export default __webpack_public_path__ + "static/integrations_instagram-2bb32b8508325484912928c8afa18e1c.png";